import { render } from "./SwdButton.vue?vue&type=template&id=73aae509"
import script from "./SwdButton.vue?vue&type=script&lang=js"
export * from "./SwdButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__